var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c("LockInfo", { staticClass: "mb-3" }),
      _vm._v(" "),
      _c("div", { staticClass: "tag-sections" }, [
        _c(
          "section",
          { staticClass: "tag" },
          [
            _c("CharacteristicSelectInline", {
              attrs: {
                "characteristic-items": _vm.functionCharacteristicItems,
                "characteristic-type": _vm.meta.functionType,
                "initial-amount": !_vm.functionsValid ? 10 : 1000,
                "show-multiple-hint": "",
                "supplements-config": {
                  nothingAllowed: false,
                  types: _vm.supplementTypes
                },
                "fan-config": {
                  showMultipleHint: true,
                  withKeyword: true,
                  titleFormats: {
                    default:
                      "Welche Tätigkeiten und Aufgaben im Bereich <br />%characteristicLabel%?",
                    level: {
                      1: "Welche Tätigkeiten und Aufgaben im Bereich <br />%title%?"
                    }
                  },
                  searchConfig: {
                    catalog: _vm.meta.searchCatalogFunction
                  }
                },
                "search-catalog": _vm.meta.searchCatalogFunction,
                "with-keyword": "",
                "keyword-placeholder":
                  "Tätigkeit, Aufgabenbereich eingeben (mind. 3 Zeichen)",
                "group-by-letter": {
                  enabled: true
                },
                "label-type": _vm.labelTypeJobProfile
              },
              on: { input: _vm.emitChangeEvent },
              model: {
                value: _vm.functions,
                callback: function($$v) {
                  _vm.functions = $$v
                },
                expression: "functions"
              }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }